import { fetchApiDataV2, getVvLink } from "../../utils/utils"

export const getTrailer = async (appInfo,teaser_vanity_url)=>{
  const api=`trailer/${teaser_vanity_url}`
  const params = getVvLink() ? { vv_link: getVvLink() } : {};
  return await fetchApiDataV2(appInfo,api,params)
}

